export class MissingFirebaseFirestoreEmulatorConfig extends Error {
  constructor() {
    super("Firebase Firestore emulator configs are missing. Check .env file");
    this.name = "Firebase Firestore emulator config missing";
  }
}
